import { IsConnectedResponse, WorkspaceIdRequest } from '../request-response';
import { ResourceName } from '../resource-name';

export const SlackGate = {
  resource: ResourceName.slack,
  actions: {
    isConnected: 'is-connected',
    updateBotToken: 'update-bot-token',
    sendMessage: 'send-message',
  },
};

export type ResumeGateActionTypes = {
  isConnected: {
    request: WorkspaceIdRequest;
    response: IsConnectedResponse;
  };
  updateBotToken: {
    request: AddBotTokenRequest;
    response: any;
  };
  sendMessage: {
    request: SendMessageRequest;
    response: any;
  };
};

export interface AddBotTokenRequest {
  workspaceId: string;
  botToken: string;
}

export interface SendMessageRequest {
  workspaceId: string;
  channelId: string;
  blocks: any[];
}
